module.exports = __webpack_public_path__ + "static/media/swipping_dai_new.20c29984.gif";